export const myMixin = {
  data(){
    return {
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0,
    }
  },
  methods: {
      onScroll() {

      if (window.pageYOffset < 0) {
        return
      }

      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 300) {
        return
      }
      
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
      },  
  },
  mounted(){
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener('scroll', this.onScroll);
    const viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    viewportMeta.content = 'width=device-width, initial-scale=1';
    document.head.appendChild(viewportMeta);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },



  }


